// Copie fiable multi-navigateurs (y compris iOS/Safari), utilisable AVANT l'ouverture
// d'onglets (window.open fait perdre le focus et annule navigator.clipboard).
// Stratégie : sélection + execCommand('copy') synchrone (compatible iOS via Range),
// renforcée par l'API clipboard asynchrone en repli.
export function copyTextReliable(text) {
  if (!text) return false;
  let ok = false;
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.contentEditable = "true";
    ta.readOnly = false;
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.width = "1px";
    ta.style.height = "1px";
    ta.style.padding = "0";
    ta.style.border = "none";
    ta.style.outline = "none";
    ta.style.boxShadow = "none";
    ta.style.background = "transparent";
    ta.style.fontSize = "16px"; // évite le zoom iOS
    document.body.appendChild(ta);

    const isIOS = /ipad|iphone|ipod/i.test(navigator.userAgent || "");
    if (isIOS) {
      const range = document.createRange();
      range.selectNodeContents(ta);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      ta.setSelectionRange(0, text.length);
    } else {
      ta.focus();
      ta.select();
      ta.setSelectionRange(0, text.length);
    }
    ok = document.execCommand("copy");
    document.body.removeChild(ta);
  } catch (e) {
    console.debug("copy execCommand", e);
  }
  // Renfort asynchrone (fire-and-forget) tant que le document a encore le focus.
  try {
    navigator.clipboard?.writeText(text);
  } catch (e) {
    console.debug("copy clipboard api", e);
  }
  return ok;
}
